/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.additionalProducts.addToCart": "Add to order",
  "i18n.additionalProducts.emotionalHook": "♥️ Most added:",
  "i18n.additionalProducts.productDescription": "Product description",
  "i18n.additionalProducts.showMore": "More information",
  "i18n.additionalProducts.title": "Accessories",
  "i18n.button.addToCart": "Add to cart",
  "i18n.button.cropImage": "",
  "i18n.button.apply": "Apply",
  "i18n.button.back": "Back",
  "i18n.button.cancel": "Cancel",
  "i18n.button.cancelAndFix": "",
  "i18n.button.cancelAndAddImage": "",
  "i18n.button.close": "Close",
  "i18n.button.continue": "Continue",
  "i18n.button.ignore": "Ignore",
  "i18n.button.ignoreAndContinue": "Continue anyway",
  "i18n.button.ignoreAndContinueOrder": "",
  "i18n.button.mobile.createNewTextPlaceholders": "Text",
  "i18n.button.noChanges": "No Thanks, close Window",
  "i18n.button.design": "",
  "i18n.button.photos": "Photos",
  "i18n.button.retry": "Retry",
  "i18n.button.uploadPhotos": "Upload photo(s)",
  "i18n.button.withSmartSorted": "Upgrade to SMART SORTED",
  "i18n.button.withoutSmartSorted": "No Thanks, close Window",
  "i18n.button.continueDesigning": "",
  "i18n.button.returnToHomePage": "",
  "i18n.button.deleteImage": "",
  "i18n.button.withoutPhoto": "",
  "i18n.button.withoutThisPhoto": "",
  "i18n.button.chooseNewImage": "",
  "i18n.button.chooseOtherPhoto": "",
  "i18n.button.retryPhoto": "",
  "i18n.button.reload": "",
  "i18n.button.restartDesigner": "",
  "i18n.button.restart": "",
  "i18n.button.puzzleYouShop": "",
  "i18n.button.shop": "",
  "i18n.button.changeProduct": "",
  "i18n.button.keepProduct": "",
  "i18n.toggle.hidePuzzleOverlay": "",
  "i18n.toggle.showPuzzleOverlay": "",
  "i18n.toggle.hide": "",
  "i18n.toggle.showUsedImages": "",
  "i18n.toggle.hideUsedImages": "",
  "i18n.imagePromoter.title": "",
  "i18n.imagePromoter.content": "",
  "i18n.boxPromoter.title.puzzle": "",
  "i18n.boxPromoter.title.memo": "",
  "i18n.boxPromoter.title.default": "",
  "i18n.boxPromoter.content.designsAndText": "",
  "i18n.boxPromoter.content.designs": "",
  "i18n.boxPromoter.content.text": "",
  "i18n.control.actionBar.duplicate": "",
  "i18n.control.actionBar.editText": "",
  "i18n.control.actionBar.leaveTextEditing": "",
  "i18n.control.actionBar.delete": "",
  "i18n.control.actionBar.rotate": "",
  "i18n.control.colorChooser.matchingColors": "",
  "i18n.control.colorChooser.allColors": "",
  "i18n.control.colorChooser.allBgColors": "",
  "i18n.control.colorChooser.lowContrastHint": "",
  "i18n.control.fontChooser.group.classic": "",
  "i18n.control.fontChooser.group.creative": "",
  "i18n.control.fontChooser.group.handwritten": "",
  "i18n.control.fontChooser.group.modern": "",
  "i18n.control.fontChooser.group.technical": "",
  "i18n.control.imageQuality.title.good": "",
  "i18n.control.imageQuality.title.medium": "",
  "i18n.control.imageQuality.title.bad": "",
  "i18n.control.imageQuality.content.good": "",
  "i18n.control.imageQuality.content.medium": "",
  "i18n.control.imageQuality.content.bad": "",
  "i18n.control.imageQuality.affectedImages": [
    "",
    ""
  ],
  "i18n.control.imageQuality.showIndicators": "",
  "i18n.control.imageQuality.hideIndicators": "",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.textEditing.menu.fonts": "",
  "i18n.control.textEditing.menu.effects": "",
  "i18n.control.textEditing.menu.colors": "",
  "i18n.control.textEditing.menu.bgColors": "",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Please shorten the text / line to fit.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "The chosen font is too large.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "This is the maximum possible size for this font and text.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "This is the minimum possible size for this font and text.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Please insert a line break",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Please continue writing on a second line or enlarge the text box",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Please check your text - not all characters are supported by this font.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Please shorten the text / line to fit.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Please enlarge the text box",
  "i18n.dialog.closeDesigner.message": "",
  "i18n.dialog.closeDesigner.title": "",
  "i18n.dialog.deletePlaceholder.message": "This step cannot be undone",
  "i18n.dialog.deletePlaceholder.title": "Do you want to delete the place holder?",
  "i18n.dialog.deleteGalleryImage.title": "",
  "i18n.dialog.deleteGalleryImage.message": "",
  "i18n.dialog.insufficientImageQuality.message": "The resolution of the image is too low - printed puzzle may appear blurry.",
  "i18n.dialog.smartSorted.message": "With SMART SORTED you can complete your 1000-piece puzzle without sorting, even without knowing the final design!",
  "i18n.dialog.smartSorted.title": "Puzzle success guaranteed",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Please click on \"{{text}}\", to change the box title.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "The box title has not been changed",
  "i18n.dialog.unchangedPlaceholders.buttons.addTitle.label": "",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Continue without a box title",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Please check your design! A text placeholder has not been changed.",
    "Please check your design! Some text placeholders have not been changed."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.title": "unchanged placeholders",
  "i18n.dialog.productChooserWarning.title": "",
  "i18n.dialog.productChooserWarning.message": "",
  "i18n.dialog.imageQuality.title": "",
  "i18n.dialog.imageQuality.indicator.good": "",
  "i18n.dialog.imageQuality.indicator.medium": "",
  "i18n.dialog.imageQuality.indicator.bad": "",
  "i18n.dialog.imageQuality.subtitle.good": "",
  "i18n.dialog.imageQuality.subtitle.medium": "",
  "i18n.dialog.imageQuality.subtitle.bad": "",
  "i18n.dialog.imageQuality.content.good": "",
  "i18n.dialog.imageQuality.content.medium": "",
  "i18n.dialog.imageQuality.content.bad": "",
  "i18n.error.deprecatedBrowserError.message": "",
  "i18n.error.deprecatedBrowserError.title": "",
  "i18n.error.designerExpiredError.message": "The designing process has been interrupted by a too-long pause, causing that it cannot be continued. Please start the designing process again.",
  "i18n.error.designerExpiredError.title": "",
  "i18n.error.fontLoadingError.message": "",
  "i18n.error.fontLoadingError.title": "",
  "i18n.error.imageLoadingError.message": "A photo could not be loaded and has been removed.",
  "i18n.error.imageLoadingError.title": "Download error",
  "i18n.error.imageProvisionError.message": "One or more photos could not be processed. The media type is probably not supported.",
  "i18n.error.imageProvisionError.title": "",
  "i18n.error.imageSelectionError.message": "File \"{{reference1}}\" could not be processed.",
  "i18n.error.imageSelectionError.title": "Error during photo upload",
  "i18n.error.imageSizeLimitExceededError.message": "The photo you uploaded is too large.\nPlease reduce your photo below 180 megapixels and upload it again.",
  "i18n.error.imageSizeLimitExceededError.title": "Error during photo upload",
  "i18n.error.imageUploadError.message": "An internet connection problem occurred.\nPlease try again later.",
  "i18n.error.imageUploadError.title": "Error during photo upload",
  "i18n.error.inlineSVGLoadingError.message": "",
  "i18n.error.inlineSVGLoadingError.title": "",
  "i18n.error.invalidCharConfigError.message": "This font is not applicable. Please choose another font.",
  "i18n.error.invalidCharConfigError.title": "Font not applicable",
  "i18n.error.malformedProductError.message": "",
  "i18n.error.malformedProductError.title": "",
  "i18n.error.notInStockError.message": "",
  "i18n.error.notInStockError.title": "",
  "i18n.error.offlineNotice": "Your internet connection seems to have been interrupted. You may continue designing your product as soon as your connection has been restored.",
  "i18n.error.templateLoadingError.message": "Template \"{{ error.reference[0] }}\" could not be loaded.\nPlease try again later.",
  "i18n.error.templateLoadingError.title": "Download error",
  "i18n.error.traudlLoadingError.message": "",
  "i18n.error.traudlLoadingError.title": "",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" has an unsupported media type.",
  "i18n.error.unsupportedMediaTypeError.title": "Error during photo upload",
  "i18n.error.uploadProductError.message": "One or some products could not be transferred to the server.\nPlease try again later.",
  "i18n.error.uploadProductError.title": "Transfer error",
  "i18n.error.zoomModeError.message": "The text from your previous layout could not be applied. Please enter a new text.",
  "i18n.error.zoomModeError.title": "Text not applied",
  "i18n.gallery.uploadPhotos.title": "",
  "i18n.gallery.uploadPhotos.message": "",
  "i18n.gallery.placedAllPhotos.title": "",
  "i18n.gallery.placedAllPhotos.message": "",
  "i18n.price.price": "Price",
  "i18n.price.reduction": "You save",
  "i18n.price.total": "Total price",
  "i18n.priceDisplay.times": [
    "{{value}} Item at {{pricePerUnit}}",
    "{{value}} Items at {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Select accessories",
  "i18n.progressOverlay.message.lines.one": "Thanks for your carefully designed creation.",
  "i18n.progressOverlay.message.lines.two": "We are preparing the following step for you...",
  "i18n.template.insertText": "Enter text here",
  "i18n.toolbox.image.title": "Edit photo",
  "i18n.toolbox.layout.template.count": [
    "",
    ""
  ],
  "i18n.toolbox.layout.template.inUse": "",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 photo",
    "{{value}} photos"
  ],
  "i18n.toolbox.layout.title": "",
  "i18n.toolbox.layout.titleBox": "",
  "i18n.toolbox.preview.title": "3D Preview",
  "i18n.toolbox.productChooser.title": "Change product",
  "i18n.toolbox.productChooser.triggerText": "Product",
  "i18n.toolbox.productChooser.contentMessage.one": "",
  "i18n.toolbox.productChooser.contentMessage.two": "",
  "i18n.toolbox.textEdit.title": "",
  "i18n.toolbox.textEdit.noPlaceholdersTitle": "",
  "i18n.toolbox.textEdit.noPlaceholdersMessage": "",
  "i18n.toolbox.textEdit.noPlaceholdersButton": "",
  "i18n.toolbox.text.title": "Edit text",
  "i18n.toolbox.imageEdit.title": "",
  "i18n.toolbox.imageEdit.removeImageMobile": "",
  "i18n.toolbox.imageEdit.removeImageDesktop": "",
  "i18n.toolbox.imageEdit.swapImage": ""
};


export class LocaleEnUS {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
